<template>
  <v-form ref="AccountabilityForm" v-model="validForm" lazy-validation class="mt-0 pt-0">
    <h2 class="text-xs-left">Dados da prestação</h2>
    <v-layout wrap pr-5>
      <v-flex sm6 px-4 pt-3>
        <v-autocomplete
          :rules="$store.state.formRules.requiredSelect"
          v-model="formData.condominium_id"
          :items="condominiumsList"
          item-text="name_fantasy"
          item-value="id"
          label="Selecione o condomínio"
          @change="getYears"
          :disabled="viewForm"
        ></v-autocomplete>
      </v-flex>

      <v-flex sm6 pl-4 pt-3>
        <v-autocomplete
          v-model="formData.account_year_id"
          :rules="$store.state.formRules.requiredSelect"
          :items="operationsYears"
          item-text="year"
          item-value="id"
          label="Exercício"
          :disabled="viewForm"
        ></v-autocomplete>
      </v-flex>

      <v-flex sm6 px-4>
        <v-menu
          v-model="date_limit_menu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              clearable
              v-model="date_limit_formated"
              mask="##/##/####"
              return-masked-value
              label="Data limite"
              v-on="on"
              :disabled="viewForm"
            ></v-text-field>
          </template>
          <v-date-picker no-title v-model="formData.date_limit" @input="date_limit_menu = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex sm6 pl-4>
        <v-autocomplete
          v-model="formData.period"
          :rules="$store.state.formRules.required"
          :items="periodsTypes"
          label="Periodicidade"
          :disabled="viewForm"
        ></v-autocomplete>
      </v-flex>
      <v-flex sm6 px-4>
        <v-menu
          v-model="date_approve_menu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              clearable
              return-masked-value
              mask="##/##/####"
              v-model="date_approve_formated"
              label="Data de aprovação em assembléia"
              v-on="on"
              :disabled="viewForm"
            ></v-text-field>
          </template>
          <v-date-picker
            no-title
            v-model="formData.date_approve"
            @input="date_approve_menu = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs6 px-4 pt-4>
        <v-textarea solo name="input-7-4" label="Observações" v-model="formData.observation" :disabled="viewForm"></v-textarea>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
const defaultAccountabilityForm = {
  condominium_id: "",
  period: "",
  date_limit: "",
  date_approve: "",
  account_year_id: "",
};
import * as moment from "moment";

export default {
  name: "AccountabilityForm",

  props: { 
    dialog: Boolean, 
    data: Object, 
    condominiumsList: Array, 
    viewForm: Boolean
  },

  data() {
    return {
      periodsTypes: ["anual", "semestral", "trimestral"],
      //   periodsTypes: [
      //     { text: "Anual", id: "anual" },
      //     { text: "Semestral", id: "semestral" },
      //     { text: "Trimestral", id: "trimestral" },
      //   ],
      operationsYears: [],
      validForm: true,
      formData: {},
      date_limit_menu: false,
      date_approve_menu: false,
    };
  },

  watch: {
    dialog(v) {
      if (!v) {
        this.operationsYears = [];
        this.formData = { ...defaultAccountabilityForm };
      } else {
        this.$refs.AccountabilityForm.resetValidation();
        //console.log(this.data);
        console.log(this.data);
        this.formData = { ...this.data };
        if (this.data.condominium_id) {
          this.getYears();
        }
      }
    },
  },

  methods: {
    getYears() {
      let obj = {
        url: "/api/accounting_year",
        query: { condominium_id: this.formData.condominium_id },
        method: "post",
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response) {
          return;
        }
        if (!response.data.length) {
          this.formData.account_year_id = "";
          let obj = {
            message: `O condomínio selecionado não possui exercícios cadastrados.`,
            title: "Ops!",
            callback: (_) => {},
            type: "warning",
            btConfirm: { name: "Sim", show: false },
            btCancel: { name: "Ok", show: true },
          };
          this.$store.commit("confirmMessage/showConfirmMessage", obj);
        }
        this.operationsYears = response.data;
      });
    },
  },

  computed: {
    date_approve_formated: {
      get() {
        return this.formData.date_approve
          ? moment(this.formData.date_approve).format("DD/MM/YYYY")
          : "";
      },
      set(value) {
        if (value) {
          if (value.length < 10) return;
          let arrs = value.split("/");
          let date = `${arrs[2]}-${arrs[1]}-${arrs[0]}`;
          if (!moment(date).isValid()) {
            this.formData.date_approve = new Date().toISOString().substr(0, 10);
            return;
          }
          this.formData.date_approve = date;
        } else {
          this.formData.date_approve = "";
        }
      },
    },
    date_limit_formated: {
      get() {
        return this.formData.date_limit
          ? moment(this.formData.date_limit).format("DD/MM/YYYY")
          : "";
      },
      set(value) {
        if (value) {
          if (value.length < 10) return;
          let arrs = value.split("/");
          let date = `${arrs[2]}-${arrs[1]}-${arrs[0]}`;
          if (!moment(date).isValid()) {
            this.formData.date_limit = new Date().toISOString().substr(0, 10);
            return;
          }
          this.formData.date_limit = date;
        } else {
          this.formData.date_limit = "";
        }
      },
    },
  },
};
</script>

<style>
</style>